import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./Components/Layout";
import VyraHome from "./Components/HomePage/Home";
import VyraProduct from "./Components/MedProducts/products";
import ProductDetail from "./Components/MedProducts/ProductDetails";
import VyraAbout from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/ContactUs/Contact";
import Login from "./pages/Login";
import Unauthorized from "./pages/Unauthorized";
import AdminDashboard from "./pages/Admin/Dashboard";
import AdminEmployees from "./pages/Admin/Employees";
import CreateEmployee from "./pages/Admin/CreateEmployee";
import EditEmployee from "./pages/Admin/CreateEmployee";
import AdminDCRReports from "./pages/Admin/DCRReports";
import EmployeeDashboard from "./pages/Employee/Dashboard";
import EmployeeDCR from "./pages/Employee/DCR";
import EmployeeDCRReport from "./pages/Employee/DCRReport";
import { AdminRoute, EmployeeRoute, PublicRoute } from "./routes/ProtectedRoute";
import AdminLayout from "./Components/AdminLayout";
import EmployeeLayout from "./Components/EmployeeLayout";

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { path: "/", element: <VyraHome /> },
        { path: "/products", element: <VyraProduct /> },
        { path: "/product/:id", element: <ProductDetail /> },
        { path: "/about", element: <VyraAbout /> },
        { path: "/contact", element: <ContactUs /> },
      ],
    },
    {
      path: "/login",
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: "/unauthorized",
      element: <Unauthorized />,
    },
    {
      element: (
        <AdminRoute>
          <AdminLayout />
        </AdminRoute>
      ),
      children: [
        { path: "/admin/dashboard", element: <AdminDashboard /> },
        { path: "/admin/employees", element: <AdminEmployees /> },
        { path: "/admin/create-employee", element: <CreateEmployee /> },
        { path: "/admin/edit-employee/:id", element: <EditEmployee /> },
        { path: "/admin/dcr-reports", element: <AdminDCRReports /> },
      ],
    },
    {
      element: (
        <EmployeeRoute>
          <EmployeeLayout />
        </EmployeeRoute>
      ),
      children: [
        { path: "/employee/dashboard", element: <EmployeeDashboard /> },
        { path: "/employee/dcr", element: <EmployeeDCR /> },
        { path: "/employee/dcr-report", element: <EmployeeDCRReport /> },
      ],
    },
    {
      path: "*",
      element: <div>404 - Page Not Found</div>,
    },
  ],
  { scrollRestoration: true },
);

function App() {
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
